import { RecentHistory } from '../types';

interface IRecentHistoryState {
  recentHistory: Array<RecentHistory>;
}

export const selectRecentHistory = (state: IRecentHistoryState): Array<RecentHistory> =>
  state.recentHistory;
